import { DEFAULT_OG_IMAGE, SITE_URL } from "@/lib/constants/site-url"
import AccessibilityPage from "@/pages/accessibility"
import { createFileRoute } from "@tanstack/react-router"

const OG_IMAGE = DEFAULT_OG_IMAGE

export const Route = createFileRoute("/$countryCode/accessibility")({
  head: () => {
    const title = "Accessibility Statement | +Bake Cafe"
    const description =
      "Read +Bake Cafe's Accessibility Statement and learn how to contact the team with website accessibility feedback or support requests."
    const canonical = `${SITE_URL}/accessibility`

    const breadcrumbSchema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: SITE_URL },
        {
          "@type": "ListItem",
          position: 2,
          name: "Accessibility",
          item: canonical,
        },
      ],
    }

    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:type", content: "website" },
        { property: "og:url", content: canonical },
        { property: "og:image", content: OG_IMAGE },
        { property: "og:site_name", content: "+Bake Cafe" },
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:title", content: title },
        { name: "twitter:description", content: description },
        { name: "twitter:image", content: OG_IMAGE },
      ],
      links: [{ rel: "canonical", href: canonical }],
      scripts: [{ type: "application/ld+json", children: JSON.stringify(breadcrumbSchema) }],
    }
  },
  component: AccessibilityPage,
})
